import Footer from '../../components/Footer';
import Header from '../../components/Header';
import InsureSection from '../../components/InsureSection';
import './styles.css';

function Insure() {

    return (
        <div className="container-home">
            <Header />
            <InsureSection />
            <Footer />
        </div>
    );
}

export default Insure;